module.exports = __webpack_public_path__ + "img/ferienhaus_debontje_greetsiel_terrasse_03.f62694be.jpg";